<template>
  <div>
    <div class="form-group">
      <label class="col-xs-12">問合せID</label>
      <div class="col-xs-12">
        <input type="text" class="form-control" v-model="params.contact_id">
      </div>
    </div>
    <div class="form-group">
      <div class="col-xs-12">
        <button class="btn btn-block btn-primary" v-on:click="test">検索</button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        params: {
          page: 1,
          contact_id: ''
        }
      }
    },
    methods: {
      test: function () {
        this.params.page = 1
        this.$emit('click', this.params)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Search.vue?3089ab8a